module.exports = __webpack_public_path__ + "img/DSCF0971.09a93aeb.jpeg";